module.exports = __webpack_public_path__ + "img/logo-move-pro.6c5d33bd.svg";